/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable jsx-a11y/img-redundant-alt */
/*
 * Created Date: 18-10-2023, 9:42:34 am
 * Author: Peter
 * Email: phantrung696@gmail.com
 * -----
 * Last Modified: Wed Oct 18 2023
 * Modified By: Peter
 * -----
 * Copyright (c) 2023 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import { cloneDeep, map, startsWith } from 'lodash'
import { getS3Url } from './Url'
import { QUESTION_TYPE } from '@Core/Components/const'
import { REGEX } from './Yup'
import { timeAgoSeconds } from './Date'
import React from 'react'
import { getDataSession, SESSION_STORAGE } from './Session'

const CustomImage = ({ src, alt, style = {}, ...props }) => {
	const isDownloadingExam = getDataSession(SESSION_STORAGE, 'downloading_exam')
	const [loading, setLoading] = React.useState(isDownloadingExam ? undefined : 'lazy')
	// const handleLoad = () => {
	// 	setLoaded(true)
	// }
	// if (!loaded) return null
	return <img src={getS3Url(src)} alt={alt || 'image'} style={style} loading={loading} {...props} />
}

export const renderMedia = question => {
	return Array.isArray(question?.files) && question?.files?.length > 0
		? question?.files?.map((item, index) => {
				if (item?.type === 'AUDIO') {
					return (
						<div className="w-auto mb-20">
							<audio controls className="mx-auto">
								<source src={getS3Url(item?.name) ?? '/'} />
							</audio>
						</div>
					)
				}
				if (item?.type === 'VIDEO') {
					return renderVideoYoutube(item?.name)
				}
				return (
					<CustomImage
						key={index}
						src={item.url}
						width="100%"
						height="auto"
						style={{
							maxWidth: 500,
							marginBottom: 10,
							maxHeight: 300
						}}
						// loading="lazy"
						alt="image"
						// crossOrigin="anonymous"
					/>
				)
		  })
		: null
}

export const renderVideoYoutube = url => {
	const regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/
	const match = url.match(regExp)
	if (match && match[2].length == 11) {
		const newUrl = `https://www.youtube.com/embed/${match[2]}`
		return (
			<iframe
				src={newUrl}
				frameBorder="1"
				AllowFullScreen
				className="block w-full mx-auto mb-12 h-[200px] sm:h-[300px]"
			/>
		)
	}
	return null
}

export const convertSectionQuestionText = (text, t, isForSection = false) => {
	const arrayLine = text.split('\n')
	let textToObject = {}
	let count = 1
	let currentSection = ''

	if (isForSection) {
		currentSection = 'P1'
		const text = arrayLine.filter(item => {
			return !startsWith(item, "'")
		})
		textToObject = {
			[currentSection]: text
		}
	} else {
		arrayLine.forEach(item => {
			if (startsWith(item, "'")) {
				currentSection = item?.split("'")?.pop() ? item?.split("'")?.pop() : t('section', { count })

				textToObject = {
					...textToObject,
					[currentSection]: []
				}
				count += 1
			} else if (currentSection) {
				textToObject?.[currentSection]?.push(item)
			} else {
				currentSection = t('Phần {{count}}', { count: 1 })
				textToObject = {
					...textToObject,
					[currentSection]: [item]
				}
				count += 1
			}
		})
	}

	function convertSectionV2(section, list_questions) {
		const section_name = section
		const questionString = list_questions.join('\n')
		const questions = formatTextToArr(questionString)
		return {
			section_name,
			questions
		}
	}

	return Object?.keys(textToObject)?.map(key => convertSectionV2(key, textToObject[key]))
}

export const formatTextToArr = text => {
	const regexQsReading = /\[READ-.\]/g
	const splitText = text.trim().split(/\r?\n|\r|\n/g)
	let lengthArrQs = 0
	const arrQuestionText = []

	splitText.forEach((item, index) => {
		if (item === '' && splitText[index + 1] !== '') {
			// check mỗi khi xuống dòng thì là 1 câu hỏi mới
			lengthArrQs += 1
		} else if (item !== '') {
			// tên câu hỏi và câu trả lời sẽ cùng 1 array (tên câu hỏi sẽ là phần tử đầu tiên)
			arrQuestionText[lengthArrQs] = [...(arrQuestionText?.[lengthArrQs] ?? []), item]
		}
	})

	const positionChildrenQs = []

	const questions = arrQuestionText
		?.map((item, index) => {
			// console.log('============= item', item)
			const nameQs = item?.[0] ?? ''
			const isStartsWithReadingQs = new RegExp(regexQsReading).test(nameQs.slice(0, 8))
			const numberChildrenQs = isStartsWithReadingQs ? Number(nameQs.slice(1, 7).split('-')?.[1]) : 0
			if (numberChildrenQs > 0) {
				for (let i = index + 1; i <= index + numberChildrenQs; i++) {
					positionChildrenQs.push(i)
				}
			}

			const arrayTextAnswer = item.slice(1)
			// console.log('============= arrayTextAnswer', arrayTextAnswer)
			const typeAndNameQs = () => {
				// boolean
				if (nameQs?.startsWith('[TF]')) return { type: 'BOOLEAN', name: nameQs.slice(4) }
				// fill word
				if (nameQs?.startsWith('[FILL]')) return { type: 'FILL_WORD', name: nameQs.slice(6) }
				// reading
				if (isStartsWithReadingQs)
					return {
						type: 'READING',
						name: nameQs.slice(8)
					}
				// multiple
				if (arrayTextAnswer?.filter(i => i.startsWith('*'))?.length > 1)
					return { type: 'MULTIPLE', name: nameQs }
				// single
				return { type: 'SINGLE', name: nameQs }
			}

			return {
				...typeAndNameQs(),
				answers: arrayTextAnswer.map(answer => ({
					option: answer.startsWith('*') ? answer.slice(1) : answer,
					is_correct: !!answer.startsWith('*')
				})),
				children_question:
					arrQuestionText
						.slice(index + 1, index + numberChildrenQs + 1)
						?.map(item => ({
							name: item?.[0],
							answers:
								item.slice(1).map(answer => ({
									option: answer.startsWith('*') ? answer.slice(1) : answer,
									is_correct: !!answer.startsWith('*')
								})) ?? []
						}))
						.filter(x => x?.answers?.length > 0) ?? []
			}
		})
		.filter((x, index) => !positionChildrenQs.includes(index)) // xóa những câu hỏi con trong mảng theo vị trí

	const correctQuestions =
		questions.filter(
			x =>
				(['BOOLEAN', 'SINGLE', 'MULTIPLE'].includes(x?.type) && x?.answers.length > 0) ||
				(x?.type === 'READING' && x?.children_question?.length > 0) ||
				(x?.type === 'FILL_WORD' && x?.name.length > 0)
		) ?? []
	const wrongQuestions = questions.filter(x => x?.type !== 'FILL_WORD' && x?.answers < 1) ?? []

	// console.log('============= correctQuestions', correctQuestions)
	// console.log('============= wrongQuestions', wrongQuestions)

	return { correctQuestions, wrongQuestions }
}

export const transformArray = data => {
	const transformedArray = []

	data.forEach(item => {
		const transformedItem = cloneDeep({ ...item, type: item.type, name: item.name })
		if (item.type === QUESTION_TYPE.fill_word) {
			const anValues = item.name.match(/\[.*?\]/g)
			let newIndex = 0
			transformedItem.name = item.name.replace(/\[.*?\]/g, '[___]')
			if (anValues) {
				anValues.forEach((value, index) => {
					const names = value
						.substring(1, value.length - 1)
						.split('|')
						.map(name => name.trim())
					const childQuestion = {
						name: `fill_word_${index}`,
						answers: names.map(n => ({ is_correct: true, option: n })),
						sort_order: index
					}
					transformedItem.children_question.push(childQuestion)
					newIndex = item.name.indexOf(value, newIndex)
				})
			}
			transformedArray.push(transformedItem)
		} else {
			transformedArray.push(transformedItem)
		}
	})
	return transformedArray
}

export const removeElementAtIndex = (inputString, indexToRemove) => {
	let match
	// eslint-disable-next-line no-plusplus
	for (let i = 0; i <= indexToRemove; i++) {
		match = REGEX.FILL_QUESTION.exec(inputString)
		if (match === null) {
			return 'Invalid index'
		}
	}
	const start = match.index
	const end = start + match[0].length
	const result = inputString.slice(0, start) + inputString.slice(end)
	return result
}

export const checkEmptyObject = obj => {
	return JSON.stringify(obj) === '{}'
}

export const checkEmptyArray = arr => {
	if (Array.isArray(arr)) {
		if (arr.length > 0) {
			if (Array.isArray(arr[0])) {
				return arr.every(item => item.length === 0)
			}
			if (typeof arr[0] === 'object') {
				return arr.every(item => checkEmptyObject(item))
			}
		}
		return arr.length === 0
	}
}

export const checkTimeFlashcard = item => {
	const minutesAgo = timeAgoSeconds(item) / 60

	if (minutesAgo <= 0) {
		return true
	}

	return false
}

export const removeLatext = (str = '') => {
	return str ? str.replace(/\[latext\]/gi, '') : str
}

export const formatBreakline = (str = '') => {
	const arr = str.split('\n')
	let content = ''
	arr.forEach(str => {
		content += `<p>${str}</p>`
	})
	return content
}

export const questionLevelOptions = [
	{
		key: 'EASY',
		label: 'Độ khó thấp',
		color: 'primary'
	},
	{
		key: 'MEDIUM',
		label: 'Độ khó trung bình',
		color: 'warning'
	},
	{
		key: 'HARD',
		label: 'Độ khó cao',
		color: 'error'
	}
]

export const getQuestionLevelOption = level => {
	return questionLevelOptions.find(i => i.key === level) ?? {}
}

export const formatQuestion = question => {
	const data = {
		...question,
		// name: formatBreakline(question?.name),
		topics: [question?.topic].filter(Boolean),
		level: getQuestionLevelOption(question?.level)?.label,
		answers: map(question?.answers, a => {
			return {
				...a,
				option: formatBreakline(a.option)
			}
		})
	}
	if (Array.isArray(question?.child_questions) && question?.child_questions.length > 0) {
		data.children_questions = question?.child_questions
		// console.log('============= data', data)
	}
	return data
}

export const formatSectionQuestions = (sections = []) => {
	return sections.map(item => {
		return {
			...item,
			// section_name: item.name,
			questions: map(item?.questions, qs => {
				return formatQuestion(qs)
			})
		}
	})
}
